import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styleUrls: ['./menu-admin.component.css']
})
export class MenuAdminComponent implements OnInit {
  ruta: string;
  rutaAgencia:string;

  constructor(
    private router: Router,
    private routeActive: ActivatedRoute
  ) { }

  ngOnInit(): void {
    //var rutaTmp = this.router.url.split('#')[0];
  

    this.ruta = ( this.router.url.split('#')[0]).split('/')[2];
    this.rutaAgencia=(this.ruta==='agencias' || this.ruta==='agencias-pendientes')?''+this.ruta:'agencias'; 
    
    
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.ruta = ( this.router.url.split('#')[0]).split('/')[2];
          
        this.rutaAgencia=(this.ruta==='agencias' || this.ruta==='agencias-pendientes')?''+this.ruta:'agencias'; 
      }
    });     
  }

}
